/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { BulkGrantPointReq } from '../_model/bulkGrantPointReq';
import type { ClaimGuestPlayPointsReq } from '../_model/claimGuestPlayPointsReq';
import type { GetClassPointHistory1Params } from '../_model/getClassPointHistory1Params';
import type { GetClassPointHistoryParams } from '../_model/getClassPointHistoryParams';
import type { GetMyPointsParams } from '../_model/getMyPointsParams';
import type { GrantPointReq } from '../_model/grantPointReq';
import type { PlayGrantPointReq } from '../_model/playGrantPointReq';
import type { PlayParticipantBalancesReq } from '../_model/playParticipantBalancesReq';
import type { PlayParticipantRegisterReq } from '../_model/playParticipantRegisterReq';
import type { SseEmitter } from '../_model/sseEmitter';
import type { SuccessBodyBulkGrantPointRes } from '../_model/successBodyBulkGrantPointRes';
import type { SuccessBodyClaimGuestPlayPointsRes } from '../_model/successBodyClaimGuestPlayPointsRes';
import type { SuccessBodyGrantPointRes } from '../_model/successBodyGrantPointRes';
import type { SuccessBodyListPlayParticipantBalanceRes } from '../_model/successBodyListPlayParticipantBalanceRes';
import type { SuccessBodyPlayGrantPointRes } from '../_model/successBodyPlayGrantPointRes';
import type { SuccessBodyPlayParticipantRegisterRes } from '../_model/successBodyPlayParticipantRegisterRes';
import type { SuccessBodyPointHistoryRes } from '../_model/successBodyPointHistoryRes';
import type { SuccessBodyTrialPointAllowanceRes } from '../_model/successBodyTrialPointAllowanceRes';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const claimGuestPlayPoints = (
  claimGuestPlayPointsReq: BodyType<ClaimGuestPlayPointsReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyClaimGuestPlayPointsRes>(
    {
      url: `/play/points/guest-claims`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: claimGuestPlayPointsReq,
      signal,
    },
    options,
  );
};

export const getClaimGuestPlayPointsMutationKey = () =>
  ['claimGuestPlayPoints'] as const;

export const getClaimGuestPlayPointsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimGuestPlayPoints>>,
    TError,
    ClaimGuestPlayPointsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimGuestPlayPoints>>,
  TError,
  ClaimGuestPlayPointsMutationVariables,
  TContext
> => {
  const mutationKey = getClaimGuestPlayPointsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimGuestPlayPoints>>,
    ClaimGuestPlayPointsMutationVariables
  > = props => {
    const { data } = props ?? {};

    return claimGuestPlayPoints(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimGuestPlayPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimGuestPlayPoints>>
>;
export type ClaimGuestPlayPointsMutationBody =
  BodyType<ClaimGuestPlayPointsReq>;
export type ClaimGuestPlayPointsMutationError = ErrorType<unknown>;
export type ClaimGuestPlayPointsMutationVariables = {
  data: BodyType<ClaimGuestPlayPointsReq>;
};

export const useClaimGuestPlayPoints = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof claimGuestPlayPoints>>,
      TError,
      ClaimGuestPlayPointsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof claimGuestPlayPoints>>,
  TError,
  ClaimGuestPlayPointsMutationVariables,
  TContext
> => {
  return useMutation(
    getClaimGuestPlayPointsMutationOptions(options),
    queryClient,
  );
};
export const grantPlayPoints = (
  playGrantPointReq: BodyType<PlayGrantPointReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPlayGrantPointRes>(
    {
      url: `/play/points/grants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: playGrantPointReq,
      signal,
    },
    options,
  );
};

export const getGrantPlayPointsMutationKey = () => ['grantPlayPoints'] as const;

export const getGrantPlayPointsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantPlayPoints>>,
    TError,
    GrantPlayPointsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantPlayPoints>>,
  TError,
  GrantPlayPointsMutationVariables,
  TContext
> => {
  const mutationKey = getGrantPlayPointsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantPlayPoints>>,
    GrantPlayPointsMutationVariables
  > = props => {
    const { data } = props ?? {};

    return grantPlayPoints(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantPlayPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantPlayPoints>>
>;
export type GrantPlayPointsMutationBody = BodyType<PlayGrantPointReq>;
export type GrantPlayPointsMutationError = ErrorType<unknown>;
export type GrantPlayPointsMutationVariables = {
  data: BodyType<PlayGrantPointReq>;
};

export const useGrantPlayPoints = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantPlayPoints>>,
      TError,
      GrantPlayPointsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantPlayPoints>>,
  TError,
  GrantPlayPointsMutationVariables,
  TContext
> => {
  return useMutation(getGrantPlayPointsMutationOptions(options), queryClient);
};
export const registerPlayParticipant = (
  playParticipantRegisterReq: BodyType<PlayParticipantRegisterReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPlayParticipantRegisterRes>(
    {
      url: `/play/participants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: playParticipantRegisterReq,
      signal,
    },
    options,
  );
};

export const getRegisterPlayParticipantMutationKey = () =>
  ['registerPlayParticipant'] as const;

export const getRegisterPlayParticipantMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPlayParticipant>>,
    TError,
    RegisterPlayParticipantMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerPlayParticipant>>,
  TError,
  RegisterPlayParticipantMutationVariables,
  TContext
> => {
  const mutationKey = getRegisterPlayParticipantMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerPlayParticipant>>,
    RegisterPlayParticipantMutationVariables
  > = props => {
    const { data } = props ?? {};

    return registerPlayParticipant(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterPlayParticipantMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerPlayParticipant>>
>;
export type RegisterPlayParticipantMutationBody =
  BodyType<PlayParticipantRegisterReq>;
export type RegisterPlayParticipantMutationError = ErrorType<unknown>;
export type RegisterPlayParticipantMutationVariables = {
  data: BodyType<PlayParticipantRegisterReq>;
};

export const useRegisterPlayParticipant = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerPlayParticipant>>,
      TError,
      RegisterPlayParticipantMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerPlayParticipant>>,
  TError,
  RegisterPlayParticipantMutationVariables,
  TContext
> => {
  return useMutation(
    getRegisterPlayParticipantMutationOptions(options),
    queryClient,
  );
};
export const getPlayParticipantBalances = (
  playParticipantBalancesReq: BodyType<PlayParticipantBalancesReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyListPlayParticipantBalanceRes>(
    {
      url: `/play/participants/balances`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: playParticipantBalancesReq,
      signal,
    },
    options,
  );
};

export const getGetPlayParticipantBalancesMutationKey = () =>
  ['getPlayParticipantBalances'] as const;

export const getGetPlayParticipantBalancesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getPlayParticipantBalances>>,
    TError,
    GetPlayParticipantBalancesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getPlayParticipantBalances>>,
  TError,
  GetPlayParticipantBalancesMutationVariables,
  TContext
> => {
  const mutationKey = getGetPlayParticipantBalancesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getPlayParticipantBalances>>,
    GetPlayParticipantBalancesMutationVariables
  > = props => {
    const { data } = props ?? {};

    return getPlayParticipantBalances(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetPlayParticipantBalancesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getPlayParticipantBalances>>
>;
export type GetPlayParticipantBalancesMutationBody =
  BodyType<PlayParticipantBalancesReq>;
export type GetPlayParticipantBalancesMutationError = ErrorType<unknown>;
export type GetPlayParticipantBalancesMutationVariables = {
  data: BodyType<PlayParticipantBalancesReq>;
};

export const useGetPlayParticipantBalances = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getPlayParticipantBalances>>,
      TError,
      GetPlayParticipantBalancesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getPlayParticipantBalances>>,
  TError,
  GetPlayParticipantBalancesMutationVariables,
  TContext
> => {
  return useMutation(
    getGetPlayParticipantBalancesMutationOptions(options),
    queryClient,
  );
};
export const grantPointsBulk = (
  classGroupId: string,
  bulkGrantPointReq: BodyType<BulkGrantPointReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyBulkGrantPointRes>(
    {
      url: `/classrooms/${classGroupId}/points/grants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkGrantPointReq,
      signal,
    },
    options,
  );
};

export const getGrantPointsBulkMutationKey = () => ['grantPointsBulk'] as const;

export const getGrantPointsBulkMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantPointsBulk>>,
    TError,
    GrantPointsBulkMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantPointsBulk>>,
  TError,
  GrantPointsBulkMutationVariables,
  TContext
> => {
  const mutationKey = getGrantPointsBulkMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantPointsBulk>>,
    GrantPointsBulkMutationVariables
  > = props => {
    const { classGroupId, data } = props ?? {};

    return grantPointsBulk(classGroupId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantPointsBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantPointsBulk>>
>;
export type GrantPointsBulkMutationBody = BodyType<BulkGrantPointReq>;
export type GrantPointsBulkMutationError = ErrorType<unknown>;
export type GrantPointsBulkMutationVariables = {
  classGroupId: string;
  data: BodyType<BulkGrantPointReq>;
};

export const useGrantPointsBulk = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantPointsBulk>>,
      TError,
      GrantPointsBulkMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantPointsBulk>>,
  TError,
  GrantPointsBulkMutationVariables,
  TContext
> => {
  return useMutation(getGrantPointsBulkMutationOptions(options), queryClient);
};
export const getClassPointHistory = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPointHistoryRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/points/grants`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassPointHistoryQueryKey = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
) => {
  return [
    `/classrooms/${classGroupId}/members/${userId}/points/grants`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassPointHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistoryQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory>>
  > = ({ signal }) =>
    getClassPointHistory(classGroupId, userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      classGroupId !== null &&
      classGroupId !== undefined &&
      userId !== null &&
      userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClassPointHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory>>
>;
export type GetClassPointHistoryQueryError = ErrorType<unknown>;

export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClassPointHistory<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClassPointHistoryQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetClassPointHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistoryQueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory>>
  > = ({ signal }) =>
    getClassPointHistory(classGroupId, userId, params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetClassPointHistorySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory>>
>;
export type GetClassPointHistorySuspenseQueryError = ErrorType<unknown>;

export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistoryParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClassPointHistorySuspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistoryParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClassPointHistorySuspenseQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const grantPoints = (
  classGroupId: string,
  userId: string,
  grantPointReq: BodyType<GrantPointReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyGrantPointRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/points/grants`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: grantPointReq,
      signal,
    },
    options,
  );
};

export const getGrantPointsMutationKey = () => ['grantPoints'] as const;

export const getGrantPointsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof grantPoints>>,
    TError,
    GrantPointsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof grantPoints>>,
  TError,
  GrantPointsMutationVariables,
  TContext
> => {
  const mutationKey = getGrantPointsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof grantPoints>>,
    GrantPointsMutationVariables
  > = props => {
    const { classGroupId, userId, data } = props ?? {};

    return grantPoints(classGroupId, userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GrantPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof grantPoints>>
>;
export type GrantPointsMutationBody = BodyType<GrantPointReq>;
export type GrantPointsMutationError = ErrorType<unknown>;
export type GrantPointsMutationVariables = {
  classGroupId: string;
  userId: string;
  data: BodyType<GrantPointReq>;
};

export const useGrantPoints = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof grantPoints>>,
      TError,
      GrantPointsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof grantPoints>>,
  TError,
  GrantPointsMutationVariables,
  TContext
> => {
  return useMutation(getGrantPointsMutationOptions(options), queryClient);
};
export const getTrialPointAllowance = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyTrialPointAllowanceRes>(
    { url: `/points/trial-allowance`, method: 'GET', signal },
    options,
  );
};

export const getGetTrialPointAllowanceQueryKey = () => {
  return [`/points/trial-allowance`] as const;
};

export const getGetTrialPointAllowanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTrialPointAllowance>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrialPointAllowanceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrialPointAllowance>>
  > = ({ signal }) => getTrialPointAllowance(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrialPointAllowance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrialPointAllowanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrialPointAllowance>>
>;
export type GetTrialPointAllowanceQueryError = ErrorType<unknown>;

export function useGetTrialPointAllowance<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialPointAllowance>>,
          TError,
          Awaited<ReturnType<typeof getTrialPointAllowance>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialPointAllowance<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialPointAllowance>>,
          TError,
          Awaited<ReturnType<typeof getTrialPointAllowance>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialPointAllowance<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTrialPointAllowance<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTrialPointAllowanceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTrialPointAllowanceSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getTrialPointAllowance>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrialPointAllowanceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrialPointAllowance>>
  > = ({ signal }) => getTrialPointAllowance(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTrialPointAllowance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetTrialPointAllowanceSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrialPointAllowance>>
>;
export type GetTrialPointAllowanceSuspenseQueryError = ErrorType<unknown>;

export function useGetTrialPointAllowanceSuspense<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialPointAllowanceSuspense<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialPointAllowanceSuspense<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTrialPointAllowanceSuspense<
  TData = Awaited<ReturnType<typeof getTrialPointAllowance>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTrialPointAllowance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTrialPointAllowanceSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getMyPoints = (
  params?: GetMyPointsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPointHistoryRes>(
    { url: `/points/me`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMyPointsQueryKey = (params?: GetMyPointsParams) => {
  return [`/points/me`, ...(params ? [params] : [])] as const;
};

export const getGetMyPointsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPointsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPoints>>> = ({
    signal,
  }) => getMyPoints(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyPointsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPoints>>
>;
export type GetMyPointsQueryError = ErrorType<unknown>;

export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyPointsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPoints>>,
          TError,
          Awaited<ReturnType<typeof getMyPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyPoints>>,
          TError,
          Awaited<ReturnType<typeof getMyPoints>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyPoints<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyPoints>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyPointsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMyPointsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyPointsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyPoints>>> = ({
    signal,
  }) => getMyPoints(params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getMyPoints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetMyPointsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyPoints>>
>;
export type GetMyPointsSuspenseQueryError = ErrorType<unknown>;

export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetMyPointsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyPointsSuspense<
  TData = Awaited<ReturnType<typeof getMyPoints>>,
  TError = ErrorType<unknown>,
>(
  params?: GetMyPointsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getMyPoints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyPointsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const subscribeMyPointEvents = (
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SseEmitter>(
    { url: `/points/events`, method: 'GET', signal },
    options,
  );
};

export const getSubscribeMyPointEventsQueryKey = () => {
  return [`/points/events`] as const;
};

export const getSubscribeMyPointEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof subscribeMyPointEvents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSubscribeMyPointEventsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>
  > = ({ signal }) => subscribeMyPointEvents(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SubscribeMyPointEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof subscribeMyPointEvents>>
>;
export type SubscribeMyPointEventsQueryError = ErrorType<unknown>;

export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscribeMyPointEvents>>,
          TError,
          Awaited<ReturnType<typeof subscribeMyPointEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscribeMyPointEvents>>,
          TError,
          Awaited<ReturnType<typeof subscribeMyPointEvents>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSubscribeMyPointEvents<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSubscribeMyPointEventsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSubscribeMyPointEventsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof subscribeMyPointEvents>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof httpsInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSubscribeMyPointEventsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>
  > = ({ signal }) => subscribeMyPointEvents(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof subscribeMyPointEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type SubscribeMyPointEventsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof subscribeMyPointEvents>>
>;
export type SubscribeMyPointEventsSuspenseQueryError = ErrorType<unknown>;

export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSubscribeMyPointEventsSuspense<
  TData = Awaited<ReturnType<typeof subscribeMyPointEvents>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof subscribeMyPointEvents>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSubscribeMyPointEventsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getClassPointHistory1 = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyPointHistoryRes>(
    {
      url: `/classrooms/${classGroupId}/members/${userId}/points`,
      method: 'GET',
      params,
      signal,
    },
    options,
  );
};

export const getGetClassPointHistory1QueryKey = (
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
) => {
  return [
    `/classrooms/${classGroupId}/members/${userId}/points`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClassPointHistory1QueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistory1QueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory1>>
  > = ({ signal }) =>
    getClassPointHistory1(classGroupId, userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      classGroupId !== null &&
      classGroupId !== undefined &&
      userId !== null &&
      userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClassPointHistory1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory1>>
>;
export type GetClassPointHistory1QueryError = ErrorType<unknown>;

export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistory1Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory1>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClassPointHistory1>>,
          TError,
          Awaited<ReturnType<typeof getClassPointHistory1>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClassPointHistory1<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClassPointHistory1QueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetClassPointHistory1SuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetClassPointHistory1QueryKey(classGroupId, userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassPointHistory1>>
  > = ({ signal }) =>
    getClassPointHistory1(classGroupId, userId, params, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClassPointHistory1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type GetClassPointHistory1SuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassPointHistory1>>
>;
export type GetClassPointHistory1SuspenseQueryError = ErrorType<unknown>;

export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params: undefined | GetClassPointHistory1Params,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetClassPointHistory1Suspense<
  TData = Awaited<ReturnType<typeof getClassPointHistory1>>,
  TError = ErrorType<unknown>,
>(
  classGroupId: string,
  userId: string,
  params?: GetClassPointHistory1Params,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClassPointHistory1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetClassPointHistory1SuspenseQueryOptions(
    classGroupId,
    userId,
    params,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
